import React from 'react';

interface LabelledInputProps {
  title: string;
  placeholder?: string;
  onChange?: any;
  disabled?: boolean;
  value?: string | number;
  type?: string;
  className?: string;
  name?: string;
  paddingTitleBottom?: string;
  titleClassName?: string;
  textColorRequired?: boolean;
}

const LabelledInput: React.FC<LabelledInputProps> = ({
  disabled = false,
  title,
  placeholder = 'placeholder',
  onChange,
  value = '',
  type = 'text',
  className = '',
  name,
  paddingTitleBottom,
  titleClassName,
  textColorRequired = true,
}) => {
  const updateValue = (e: any) => {
    onChange(e);
  };

  return (
    <div className={'w-100 mb-2 ' + className}>
      <label
        style={{ paddingBottom: paddingTitleBottom ?? '10px' }}
        className={'mt-1 vertical-center ' + (textColorRequired ? 'text-color' : '') + ' ' + (titleClassName ?? '')}
        htmlFor="labelledInput">
        {title}
      </label>
      <input
        name={name}
        disabled={disabled}
        autoComplete={'new-password'}
        className="form-control input-box input-text vertical-center"
        placeholder={placeholder}
        onChange={(e: any) => {
          e.preventDefault();
          updateValue(e);
        }}
        value={value}
        type={type}></input>
    </div>
  );
};

export default LabelledInput;
